import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconDalle: FC<IconProps> = ({ size = 40, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2689_6420)">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.5 17.0834H9.5V24.375H2.5V17.0834Z" fill="#FFFF67" />
      <path fillRule="evenodd" clipRule="evenodd" d="M9.49997 17.0834H16.5V24.375H9.49997V17.0834Z" fill="#43FFFF" />
      <path fillRule="evenodd" clipRule="evenodd" d="M16.4999 17.0834H23.4999V24.375H16.4999V17.0834Z" fill="#51DA4B" />
      <path fillRule="evenodd" clipRule="evenodd" d="M23.5001 17.0834H30.5001V24.375H23.5001V17.0834Z" fill="#FF6E3D" />
      <path fillRule="evenodd" clipRule="evenodd" d="M30.5 17.0834H37.5V24.375H30.5V17.0834Z" fill="#3C46FF" />
    </g>
    <defs>
      <clipPath id="clip0_2689_6420">
        <rect width="35" height="35" fill="white" transform="translate(2.5 2.5)" />
      </clipPath>
    </defs>
  </svg>
);

IconDalle.defaultProps = defaultIconProps;
